<template>
  <div class="content-inner-wrapper">
    <div class="select_wrap">
      <div class="select_box left"></div>
      <div class="select_box right">
        <input
          v-model="filterData.stageName"
          type="text"
          class="yioks_input"
          style="width: 160px"
          placeholder="请输入关键字"
          @keyup.enter="changeQuery(true)"
        />
        <div class="yioks_btn" @click="changeQuery(true)">搜索</div>
      </div>
    </div>
    <div class="list_wrap" v-if="!loading && !empty">
      <div class="table">
        <div class="thead">
          <div class="tr">
            <div class="th seq">序号</div>
            <div class="th stageName">申报评估考核阶段名称</div>
            <div class="th jixiaoType">评估对象</div>
            <div class="th description">评估简介</div>
            <template v-if="isInClubSystem">
              <div class="th stageStartDate">已提交</div>
              <div class="th stageEndDate">已评估</div>
            </template>
            <template v-else>
              <div class="th stageStartDate">已/未提交</div>
              <div class="th stageEndDate">已/未评估</div>
            </template>
            <div class="th action">操作</div>
          </div>
        </div>
        <div class="scrollArea">
          <vue-scroll>
            <div class="tbodyWrap">
              <div class="tbody">
                <div class="tr" v-for="(item, index) in pageList" :key="index">
                  <div class="td seq">
                    <p>{{ index + 1 }}</p>
                  </div>
                  <div class="td stageName">
                    <p :title="item.stageName">{{ item.stageName }}</p>
                  </div>
                  <div class="td jixiaoType">
                    <p :title="item.jixiaoType | performanceTypeFilter">
                      {{ item.jixiaoType | performanceTypeFilter }}
                    </p>
                  </div>
                  <div class="td description">
                    <p :title="item.description">{{ item.description }}</p>
                  </div>
                  <template v-if="isInClubSystem">
                    <div class="td stageStartDate">
                      <p>
                        {{ item.submitNum }}
                      </p>
                    </div>
                    <div class="td stageEndDate">
                      <p>
                        {{ item.auditNum }}
                      </p>
                    </div>
                  </template>
                  <template v-else>
                    <div class="td stageStartDate">
                      <p>
                        {{ item.submitNum }}&nbsp;/&nbsp;{{ item.noSubmitNum }}
                      </p>
                    </div>
                    <div class="td stageEndDate">
                      <p>
                        {{ item.auditNum }}&nbsp;/&nbsp;{{ item.noAuditNum }}
                      </p>
                    </div>
                  </template>
                  <div class="td action">
                    <p>
                      <span class="item" @click="handleCheckRow(item)"
                        >开始评估</span
                      >
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </vue-scroll>
        </div>
      </div>
    </div>

    <yioks-loading v-if="loading" />
    <yioks-empty v-if="empty && !loading" tips="暂时没有数据"></yioks-empty>
  </div>
</template>

<script>
import { getAuditStageList } from "@/api/performance";
import { performanceTypeFilter } from "@/assets/js/yioksFilters";
import mixinAppConfig from "@/mixin/mixinAppConfig";
export default {
  mixins: [mixinAppConfig],
  props: {
    isShowAddDialog: {
      type: Boolean,
      default: false,
      required: false,
    },
    page: {
      type: Number,
      default: 0,
      required: false,
    },
    total: {
      type: Number,
      default: 0,
      required: false,
    },
    pageSize: {
      type: Number,
      default: 20,
      required: false,
    },
  },

  watch: {
    page() {
      this.changeQuery();
    },
  },

  components: {
    "phase-dialog": () => import("./PerformancePhaseDialog"),
    "yioks-tips": () => import("@/components/YioksTip"),
  },

  data() {
    return {
      loading: false,
      empty: false,
      filterData: {
        stageName: "",
      },
      pageList: [],
    };
  },

  filters: {
    performanceTypeFilter,
  },

  created() {
    this.setQuery();
    this.changeQuery(true);
  },

  methods: {
    setQuery() {
      const { page, stageName } = this.$route.query;
      page && (this.page = Number(page));
      stageName && this.$set(this.filterData, "stageName", stageName);
    },

    changeQuery(flag) {
      flag && (this.page = 0);
      this.$router.replace({
        path: this.$route.fullpath,
        query: {
          ...this.$route.query,
          ...this.filterData,
          page: this.page,
          size: this.pageSize,
        },
      });
      this.loadPageList();
    },

    loadPageList() {
      const paramsData = {
        ...this.filterData,
        page: this.page,
        size: this.pageSize,
      };
      this.loading = true;
      getAuditStageList(paramsData)
        .then((res) => {
          this.loading = false;
          if (res.code) {
            this.$message.error(res.msg);
            return;
          }
          const { content, empty, totalElements } = res;
          this.empty = empty;
          this.pageList = content;
          this.$emit("update:total", totalElements);
        })
        .catch((err) => {
          this.loading = false;
          this.empty = true;
          console.error("err", err);
        });
    },

    // 操作
    handleCheckRow(row) {
      const { groupUuid, uuid: stageUuid, jixiaoType, open } = row;
      this.$router.push({
        path: "auditlist",
        query: {
          groupUuid: groupUuid,
          stageUuid: stageUuid,
          activeNav: jixiaoType,
          canEdit: open ? 1 : 2,
        },
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~@/assets/css/variable'
.content-inner-wrapper
  height 560px
.list_wrap
  flex 1
  overflow hidden
  .table
    display flex
    flex-direction column
    flex 1
    width 100%
    // margin: 30px 0 0;
    .thead, .tbody
      border 1px solid $color_white
    .thead
      margin 0 40px
      .tr
        min-height 45px
        height auto
        display flex
    .scrollArea
      height 425px
      padding-bottom 15px
      /* flex 1 */
      /* overflow hidden */
    .tbodyWrap
      display block
      // padding: 0 40px;
    .tbody
      display block
      width 810px
      margin-left auto
      margin-right auto
      max-width 810px
      border-top none
      border-bottom none
      .tr
        min-height 49px
        height auto
        display flex
        border-bottom 1px solid $color_white
    .th, .td
      height inherit
      /* flex: 1 1 auto; */
      display flex
      justify-content center
      align-items center
      font-size $font_size_medium
      border-right 1px solid $color_white
    .th:last-child, .td:last-child
      border-right none
    .td
      p
        // white-space nowrap
        // overflow hidden
        // text-overflow ellipsis
        white-space pre-line
        padding 3px 5px
        text-align center
        line-height 1.4em
        color $color_white
.seq
  width 6%
.stageName
  width 22%
.jixiaoType
  width 10%
.description
  width 23%
.stageStartDate
  width 14%
.stageEndDate
  width 14%
.action
  // width 13%
  flex 1
  .item
    cursor pointer
    user-select none
    color $green_color
  .split
    margin 0 5px
</style>

<style lang="stylus" >
.y-input
  input
    border-radius 0px !important
</style>
